import tableTips from './tableTips'

const zhCN = { tableTips: tableTips.zhCN }
const enUS = { tableTips: tableTips.enUS }
export default { zhCN, enUS }